import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled.div`
  font-size: 14px;
  color: #1a1b1c;
`;

export const Input = styled.input`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #e9edf1;
  width: 100%;
  font-size: 14px;
  text-align: start;
  color: #000;
`;

export const Textbox = styled.textarea`
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #e9edf1;
  width: 100%;
  font-size: 14px;
  height: 248px;
  color: #000;
  resize: none;
`;

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Attachments = styled.div`
  font-size: 14px;
  color: #1371fe;
  cursor: pointer;
`;

export const Button = styled.button`
  border: none;
  border-radius: 4px;
  background: #1371fe;
  padding: 8px 16px;
  color: #fff;
  font-size: 14px;
`;
